module.exports = __webpack_public_path__ + "static/media/otto.6b85e12c.svg";